module.exports = __webpack_public_path__ + "img/img-img-mype-p-coin.6287df91.svg";